export const getTarget = (key) => {
    switch(key) {
        case "margecustomentry":
            return window.i18n.__("un produit ponctuel");
        case "timetrackingentry":
            return window.i18n.__("l'entrée de timetracking");
        case "projectentry":
            return window.i18n.__("l'entrée de projet");
        case "purchase":
            return window.i18n.__("le document fournisseur");
        case "purinvoice":
        case "purInvoice":
            return window.i18n.__("la facture fournisseur");
        case "purCreditNote":
            return window.i18n.__("l'avoir fournisseur");
        case "purdelivery":
            return window.i18n.__("le bon de commande");
        case "purorder":
        case "purOrder":
            return window.i18n.__("le bon de livraison");
        case "task":
            return window.i18n.__("la tâche");
        case "event":
            return window.i18n.__("l'évènement");
        case "ticket":
            return window.i18n.__("le ticket de support");
        case "item":
            return window.i18n.__("le produit");
        case "service":
            return window.i18n.__("le service");
        case "opportunity":
            return window.i18n.__("l'opportunité");
        case "prospect":
            return window.i18n.__("le prospect");
        case "client":
        case "third":
            return window.i18n.__("le client");
        case "people":
            return window.i18n.__("le contact");
        case "society":
            return window.i18n.__("la société");
        case "supplier":
            return window.i18n.__("le fournisseur");
        case "invoice":
            return window.i18n.__("la facture");
        case "estimate":
            return window.i18n.__("le devis");
        case "creditnote":
            return window.i18n.__("l'avoir");
        case "pos":
            return window.i18n.__("la caisse");
        case "delivery":
            return window.i18n.__("le bon de livraison");
        case "document":
            return window.i18n.__("le document");
        case "order":
            return window.i18n.__("le bon de commande");
        case "proforma":
            return window.i18n.__("le proforma");
        case "proposal":
        case "propdocument":
            return window.i18n.__("le document redactor");
        case "proptemplate":
            return window.i18n.__("le modèle redactor");  
        case "support":
            return window.i18n.__("le ticket");  
        case "model":
            return window.i18n.__("le modèle");  
        case "rentbook":
            return window.i18n.__("la location");  
        case "campaign":
            return window.i18n.__("la campagne");  
        case "purDelivery":
            return window.i18n.__("le bon de livraison fournisseur");  
        case "outlooksync":
            return window.i18n.__("outlook sync");  
        case "recurring":
            return window.i18n.__("l'abonnement");  
        case "staff":
            return window.i18n.__("le collaborateur");
        default:
            return ''
    }
}